import React, { useContext, useState } from "react";
import { LangCtx } from "../../../../lib/context";
import "../../../../ui-styles/list/contactListAction.css";
import CreateDepartment from "./createDepartment";
// import { deleteDepartment } from "../../../../actions/configuration";
import DeleteConfirmModal from "../../../admin/users/components/DeleteConfirmModal";
// import Loader from "../../../../lib/ui/loader/Loader";
// import { toast } from "react-toastify";
import "../../../../ui-styles/search/Search.css";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from "@material-ui/core";
import Button from "../../../../lib/ui/buttons/Button";
import CreateSpecialization from "../specialization/createSpecialization";

const DepartmentCard = ({handleDelete, loadData, setPage, deptList,rowsPerPage,page }) => {
    const [delOpen, setOpenDelOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const [editData, setEditData] = useState(null);
    const [specilization, setSpecilization] = useState({open:false,data:null});
    // const [loading, setLoading] = useState(false);
    const { l } = useContext(LangCtx);

    const handleEditOpen = (item) => {
        setEditOpen(true);
        setEditData(item);
    };

    const handleOpen = (item) => {
        setOpenDelOpen(true);
        setEditData(item);
    };

    const handleCloseEdit = (status = false) => {
        if (status === true) {
            setPage(0);
            loadData();
            setSpecilization({open:false,dat:null})
        }
        setEditOpen(false);
    };

    const handleOpenPopUp = (id) => {
        setSpecilization({open:true,data:{departmentIds:[id]}});
    };

    const handleDeleteDep = () => {
        handleDelete(editData?._id);
        setOpenDelOpen(false);
    };

    const handleCloseEvent = (par) =>{
        if(par){
            loadData();  
        }
        setSpecilization({open:false,dat:null})

    }

    return (
        <>
            {/* {loading && <Loader/>} */}
            {/* <div className="flexCol brdrRadiusXSM pdngMD whiteBg  brdrSM fullHeight">
                <div className='flexMinHeightCol'>
                    <div className='flexCol'>
                        <span className='elslistTxtM'>{l.department_name}</span>
                        <span className='vrtclAvtrTxtL'>{item?.name}</span>
                    </div>
                    <div className='flexCol  pdngTXS'>
                        <span className='elslistTxtM'>
                            {l.code}
                        </span>
                        <span className='vrtclAvtrTxtL'>{item?.code}</span>
                    </div>
                    <div className='flexCol pdngTB8'>
                        <span className="elslistTxtM ">{l.desc} </span>
                        <span className=' titleHeading headingSM lineHight mrgnTopXS'>{item?.description}</span>
                    </div>
                </div>
                <div className='flexRow alignCenter brdrTop justifyCenter pdngXS'>
                    <div className='pTxtFlx alignCenter justifyCenter brdrRight' onClick={handleEditOpen}>
                        <div className="actionItem ">
                            <img src="/images/icons/edit-outline.png" alt="icon" className="invertPrimary" />
                        </div>
                        <span className='pointer'>{l.edit}</span>
                    </div>
                    <div className='pTxtFlx alignCenter justifyCenter ' onClick={() => handleOpen(item)}>
                        <div className="actionItem pTxtFlx">
                            <img src="/images/icons/delete-outline.png" alt="icon" className="invertPrimary" />
                        </div>
                        <span className='pointer'>{l.delete}</span>
                    </div>
                </div>
            </div> */}
            <Paper sx={{ width: "100%", mb: 2 }}>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell className="tableHead">
                                    <span className="elslistTxtM">{l.code}</span>
                                </TableCell>
                                <TableCell className="tableHead">
                                    <span className="elslistTxtM">{l.department_name}</span>
                                </TableCell>
                                <TableCell className="tableHead">
                                    <span className="elslistTxtM ">Specialization</span>
                                </TableCell>
                                <TableCell className="tableHead">
                                    <span className="elslistTxtM ">{l.desc}</span>
                                </TableCell>
                                <TableCell align="center" colSpan={2} className="tableHead">
                                    <span className="elslistTxtM ">Actions</span>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {deptList?.map((item) => (
                                <TableRow key={item?._id}>
                                    <TableCell className="capitalTxt">{item?.code}</TableCell>
                                    <TableCell className="capitalTxt">{item?.name}</TableCell>
                                    <TableCell className="capitalTxt">{item?.specilizationData && item.specilizationData.length>0 ? item.specilizationData.map((each,id)=>{if (id+1 !== item.specilizationData.length)  return `${each.name}, `; else return each.name}):
                                        <Button label="Create Specialization" type="outLine" size="sm" onClick={()=>handleOpenPopUp(item?._id)} />}
                                    </TableCell>
                                    <TableCell>{item?.description ? item?.description : "	--"}</TableCell>
                                    <TableCell>
                                        <div className="flexRow justifyCntr">
                                            <div className="flexAutoRow  alignCntr" onClick={() => handleEditOpen(item)}>
                                                <span className="flexInline primaryTxt pointer">
                                                    <div className="actionItem ">
                                                        <Tooltip title="edit">
                                                            <img
                                                                src="/images/icons/edit-outline.png"
                                                                alt="icon"
                                                                className="invertPrimary"
                                                            />
                                                        </Tooltip>
                                                    </div>
                                                </span>
                                            </div>
                                            <div className="flexAutoRow pdngHXXS alignCntr">
                                                <span className="flexInline primaryTxt pointer" onClick={() => handleOpen(item)}>
                                                    <div className="actionItem ">
                                                        <Tooltip title="delete">
                                                            <img
                                                                src="/images/icons/delete-outline.png"
                                                                alt="icon"
                                                                className="invertPrimary"
                                                            />
                                                        </Tooltip>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
            {editOpen && <CreateDepartment open={editOpen} handleClose={handleCloseEdit} deptData={editData} />}
            {delOpen && (
                <DeleteConfirmModal
                    header="department"
                    openDelete={delOpen}
                    closeDelete={() => setOpenDelOpen(false)}
                    handleDelete={handleDeleteDep}
                />
            )}
            {/* {specilization.open && <CreateSpecialization open={specilization.open} handleClose={() => setSpecilization({open:false,data:null})} UpdSpeData={specilization.data} rowsPerPage={rowsPerPage} page={page}/>}
             */}
             {specilization.open && <CreateSpecialization open={specilization.open} handleClose={handleCloseEvent} UpdSpeData={specilization.data} rowsPerPage={rowsPerPage} page={page}/>}

        </>
    );
};

export default DepartmentCard;
